import { ChangeDetectionStrategy, Component, ViewEncapsulation, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ILabelValue } from '@fi-app/shared/fi-shared-interfaces';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-sharing-settings',
    template: `
        <div class="sharing-selection-container">
            <mat-radio-group [class]="radioGroupClass" [(ngModel)]="ngModel" (ngModelChange)="doPropagateChanges()">
                @for (option of (sharingSelectionOptions || defaultSharingSelectionOptions); track option.value) {
                    <mat-radio-button class="fi-radio-button-standard" [value]="option.value">
                        {{ option.label | fiAppText }}
                    </mat-radio-button>
                }
            </mat-radio-group>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-sharing-settings' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiSharingSettingsComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiSharingSettingsComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiSharingSettingsComponent extends ControlValueAccessorValidatorBase<boolean> {
    @Input() radioGroupClass: string = '';
    @Input() sharingSelectionOptions: ILabelValue[];

    protected readonly defaultSharingSelectionOptions: ILabelValue[] = [
        {
            value: false,
            label: 'common.not_shared',
        },
        {
            value: true,
            label: 'common.share',
        },
    ];
}
